import React from 'react';
import { Field, reduxForm } from 'redux-form';

import Checkbox from '../../shared/form-elements/checkbox';

const Form = props => {

	return (
		<form className="display-flex margin-top-8">
			<div className="ui-form__element width-300">
				<Field
					name="is_showed_archived"
					placeholder={'Show archived'}
					component={Checkbox}
					onChange={() => {
						setTimeout(props.action, 200);
					}}
				/>
			</div>
		</form>
	);
};

export default reduxForm({ form: 'showActiveCampaignsForm', enableReinitialize: true })(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/campaigns/components/show-active-campaigns-form.js